/* ==========================================================================
   wiseXPD landing page behavior, Polite Worldwide
   --------------------------------------------------------------------------
   Loaded once, by the buy box section. Everything else on the page (the FAQ
   disclosures, the anchor buttons) is handled here by delegation, so adding
   another section never means adding another script tag.

   Depends on nothing in the POLITE theme. Two optional hooks are feature
   detected at runtime, cart-items.getCart() and the theme:cart-drawer:show
   event, which is how their own theme opens the drawer. If both are gone the
   page falls back to /cart rather than breaking.

   Source of truth: clients/polite-worldwide/landing-pages/ in the wisexpd
   repo. Never edit this in the Shopify theme editor.
   ========================================================================== */


  // Money, in the currency the visitor is actually being sold in.
  //
  // This hardcoded '$' and en-US until the page was pushed to a real theme and
  // opened from Bali. Shopify Markets served it in rupiah, and a Rp 12,363,000
  // necklace rendered as "$12,363,000.00": the number correct, the currency a
  // lie, which is worse than either mistake alone. The local preview could
  // never have caught it, because it only ever renders one market.
  //
  // The section emits cart.currency, not shop.currency, because the presentment
  // currency follows the market and the shop default does not. Intl knows which
  // currencies carry decimals, so IDR loses the ".00" without being special
  // cased here.
  var WX_MONEY = null;
  function wxMoney(cents) {
    if (!WX_MONEY) {
      var el = document.querySelector('[data-wx-currency]');
      WX_MONEY = {
        code: (el && el.getAttribute('data-wx-currency')) || 'USD',
        locale: (el && el.getAttribute('data-wx-locale')) || 'en-US'
      };
    }
    var n = Number(cents || 0) / 100;
    try {
      // narrowSymbol, because the theme's own {{ ... | money }} renders "Rp"
      // and the default display renders "IDR". Two spellings of the same
      // currency on one page reads as a bug even though both are correct.
      try {
        return new Intl.NumberFormat(WX_MONEY.locale, {
          style: 'currency', currency: WX_MONEY.code, currencyDisplay: 'narrowSymbol'
        }).format(n);
      } catch (e2) {
        return new Intl.NumberFormat(WX_MONEY.locale, {
          style: 'currency', currency: WX_MONEY.code
        }).format(n);
      }
    } catch (e) {
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }


(function () {
  if (window.__wxLpReady) return;
  window.__wxLpReady = true;

  /* ---------------------------------------------------------------- buy box */

  function initBuybox() {
    var root = document.querySelector('[data-wx-buybox]');
    if (!root || root.dataset.wxReady === '1') return;
    root.dataset.wxReady = '1';

    var variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-wx-variants]').textContent) || [];
    } catch (e) {
      return;
    }
    if (!variants.length) return;

    var inventory = {};
    try {
      var invEl = root.querySelector('[data-wx-inventory]');
      if (invEl) inventory = JSON.parse(invEl.textContent) || {};
    } catch (e) { inventory = {}; }

    var lpId = root.dataset.lpId || 'wx-lp';
    var leadFirst = !!root.querySelector('[data-media-id="lead"]');
    var firstRender = true;
    var chosen = (variants.find(function (v) { return v.available; }) || variants[0]).options.slice();

    // Shopify's default is the first available variant, which here is the
    // shortest length nobody buys. Open on the first of the popular lengths
    // that is actually in stock, so the fold shows an active button rather
    // than three inactive ones and a dropdown carrying the real answer.
    (function preferFeatured() {
      var group = root.querySelector('[data-wx-featured]');
      if (!group) return;
      var index = Number(group.dataset.wxOption);
      var wanted = (group.dataset.wxFeatured || '').split(',').map(function (x) { return x.trim(); });
      for (var i = 0; i < wanted.length; i++) {
        if (!wanted[i]) continue;
        var hit = variants.find(function (v) {
          return v.available && v.options[index] === wanted[i] &&
            v.options.every(function (o, k) { return k === index ? true : o === chosen[k]; });
        });
        if (hit) { chosen = hit.options.slice(); return; }
      }
    })();

    // A link that names a variant (?variant=<id>, e.g. the gold email opening
    // on 14k gold) wins over both defaults, as it does on the stock product
    // page. Only if that variant can be bought; otherwise the defaults stand.
    (function preferLinked() {
      var id;
      try { id = Number(new URLSearchParams(location.search).get('variant')); } catch (e) { return; }
      if (!id) return;
      var hit = variants.find(function (v) { return v.id === id && v.available; });
      if (hit) chosen = hit.options.slice();
    })();

    var bar = document.querySelector('[data-wx-bar]');
    var els = {
      price: root.querySelector('[data-wx-price]'),
      barPrice: bar && bar.querySelector('[data-wx-barprice]'),
      qtyInput: root.querySelector('[data-wx-qtyinput]'),
      error: root.querySelector('[data-wx-error]'),
      stock: root.querySelector('[data-wx-stock]'),
      ship: root.querySelector('[data-wx-ship]'),
      selects: [].slice.call(root.querySelectorAll('[data-wx-select]')),
      atcs: [].slice.call(document.querySelectorAll('[data-wx-atc]')),
      labels: [].slice.call(document.querySelectorAll('[data-wx-atclabel]'))
    };

    els.labels.forEach(function (l) { l.dataset.wxDefault = l.textContent.trim(); });

    var money = wxMoney;

    function matchVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      }) || null;
    }

    // Is `value` at `index` reachable, given only the choices made ABOVE it?
    // Material is greyed only when that material is gone entirely; a length is
    // greyed only when it is gone in the material currently chosen. Testing
    // against every option at once is the tempting version and it is wrong: it
    // greys out both golds simply because 15.5 inches happens to be sold out in
    // them, which reads as "we do not sell gold".
    function comboAvailable(index, value) {
      return comboMatch(index, value, true);
    }

    // Exists at all, sold out or not. A length that exists but is empty stays
    // selectable, because selecting it is how you ask to be told when it is
    // back. Disabling it would make the notify panel unreachable, which is the
    // same dead end in a different coat.
    function comboExists(index, value) {
      return comboMatch(index, value, false);
    }

    function comboMatch(index, value, mustBeAvailable) {
      return variants.some(function (v) {
        if (v.options[index] !== value) return false;
        for (var i = 0; i < index; i++) {
          if (v.options[i] !== chosen[i]) return false;
        }
        return mustBeAvailable ? v.available : true;
      });
    }

    function currentVariant() { return matchVariant(chosen); }

    var bis = root.querySelector('[data-wx-bis]');
    var cartRow = root.querySelector('[data-wx-cartrow]');

    // Sold out swaps the cart row for the notify panel rather than leaving a
    // dead button on the page.
    function renderBis(v) {
      if (!bis) return;
      var out = !!(v && !v.available);
      bis.hidden = !out;
      if (cartRow) cartRow.hidden = out;
      var msg = bis.querySelector('[data-wx-bis-msg]');
      if (msg && out) { msg.hidden = true; msg.textContent = ''; }
      var form = bis.querySelector('[data-wx-bis-form]');
      if (form && out) form.hidden = false;
      var title = bis.querySelector('[data-wx-bis-title]');
      if (title && out) {
        title.textContent = (title.dataset.template || '').replace('[variant]', pretty(v.title));
      }
    }

    if (bis) {
      bis.querySelector('[data-wx-bis-form]').addEventListener('submit', function (e) {
        e.preventDefault();
        var v = currentVariant();
        var email = bis.querySelector('[data-wx-bis-email]').value.trim();
        var msg = bis.querySelector('[data-wx-bis-msg]');
        var submit = bis.querySelector('[data-wx-bis-submit]');
        if (!v || !email || email.indexOf('@') < 1) {
          if (msg) { msg.textContent = 'Please enter an email address.'; msg.hidden = false; }
          return;
        }
        submit.disabled = true;

        // Klaviyo's public client endpoint. The company id is the public key
        // that already ships in this store's onsite script, so no secret is
        // exposed here.
        fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
              encodeURIComponent(bis.dataset.company), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2025-07-15' },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + v.id } }
              }
            }
          })
        })
          .then(function (r) {
            if (!r.ok && r.status !== 202) throw new Error('That did not go through. Try again in a moment.');
            if (msg) { msg.textContent = 'Noted. We will write to you the day this length is back.'; msg.hidden = false; }
            bis.querySelector('[data-wx-bis-form]').hidden = true;
          })
          .catch(function (err) {
            if (msg) { msg.textContent = err.message; msg.hidden = false; }
          })
          .then(function () { submit.disabled = false; });
      });
    }

    // Shopify's own option values read "30 Inches Inches" and mix casing. The
    // label is tidied for display; the value sent to the cart is never touched.
    function pretty(v) {
      return String(v == null ? '' : v)
        .replace(/Inches\s+Inches/gi, 'inches')
        .replace(/\bInches\b/g, 'inches');
    }

    function cssEscape(v) {
      return String(v == null ? '' : v).replace(/["\\]/g, '\\$&');
    }

    // Only ever speaks when Shopify is actually tracking that variant and the
    // number is real and low. No tracking, no line. That is the difference
    // between scarcity and theatre.
    function renderStock(v) {
      if (!els.stock) return;
      var threshold = Number(els.stock.dataset.threshold || 0);
      var rec = v && inventory[v.id];
      if (!v || !v.available || !rec || threshold < 1) { els.stock.hidden = true; return; }
      if (rec.m !== 'shopify' || rec.p === 'continue') { els.stock.hidden = true; return; }
      var q = Number(rec.q);
      if (!isFinite(q) || q < 1 || q > threshold) { els.stock.hidden = true; return; }
      els.stock.textContent = (els.stock.dataset.template || '{n} left').replace('{n}', q);
      els.stock.hidden = false;
    }

    function hydrate(frame) {
      if (!frame) return;
      // A clip slide carries its source on a child, not on itself, so the
      // dataset check below would skip it forever and the frame would stay on
      // its poster.
      if (frame.tagName === 'VIDEO') {
        var s = frame.querySelector('source[data-wx-src]');
        if (s) {
          s.src = s.getAttribute('data-wx-src');
          s.removeAttribute('data-wx-src');
          frame.load();
        }
        return;
      }
      if (!frame.dataset.wxSrc) return;
      frame.srcset = frame.dataset.wxSrcset || '';
      frame.src = frame.dataset.wxSrc;
      delete frame.dataset.wxSrc;
    }

    var stage = root.querySelector('.wx-buy__stage');

    function isSwipe() {
      return !!stage && stage.scrollWidth > stage.clientWidth + 4;
    }

    function activate(i, fromScroll) {
      root.querySelectorAll('[data-wx-frame]').forEach(function (f) {
        var on = Number(f.dataset.wxFrame) === i;
        if (on) hydrate(f);
        f.classList.toggle('is-active', on);
        // A clip runs only while it is the slide being looked at. Safe to pause
        // here, unlike the section rails: this fires on a discrete choice, a
        // thumb click or a settled swipe, not on a threshold something can sit
        // on the edge of.
        if (f.tagName === 'VIDEO') {
          if (on) {
            var p = f.play();
            if (p && p.catch) p.catch(function () { /* refused autoplay is fine */ });
          } else if (!f.paused) {
            f.pause();
          }
        }
      });

      // On the swipe rail the frames are laid out side by side, so activating
      // one means scrolling to it. Not when the scroll is what triggered this,
      // or the rail fights the finger.
      if (!fromScroll && isSwipe()) {
        stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
      }
      root.querySelectorAll('[data-wx-thumb]').forEach(function (t) {
        var on = Number(t.dataset.wxThumb) === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function render() {
      var v = currentVariant();

      root.querySelectorAll('[data-wx-option]').forEach(function (group) {
        var index = Number(group.dataset.wxOption);
        var label = root.querySelector('[data-wx-optvalue="' + index + '"]');
        if (label) label.textContent = pretty(chosen[index]);

        group.querySelectorAll('[data-wx-value]').forEach(function (btn) {
          var value = btn.dataset.wxValue;
          var inStock = comboAvailable(index, value);
          var exists = comboExists(index, value);
          btn.classList.toggle('is-active', value === chosen[index]);
          btn.classList.toggle('is-soldout', !inStock);
          // Only a combination that does not exist at all is unclickable.
          btn.disabled = !exists;
          btn.setAttribute('aria-disabled', exists ? 'false' : 'true');
        });
      });

      var priceText = v ? money(v.price) : 'Unavailable';
      if (els.price) els.price.textContent = priceText;
      if (els.barPrice) els.barPrice.textContent = priceText;

      var sellable = !!(v && v.available);
      els.atcs.forEach(function (b) { b.disabled = !sellable; });
      els.labels.forEach(function (l) {
        l.textContent = sellable ? l.dataset.wxDefault : 'Sold out';
      });

      if (els.error) { els.error.hidden = true; els.error.textContent = ''; }

      renderStock(v);
      renderBis(v);

      // The dropdown is a way in to the other lengths, not a readout of the
      // current one. Letting it show the chosen value made it flicker between
      // "More lengths" and "18 inches" every time a button was tapped, which
      // reads as two controls arguing. It now always says what it is.
      //
      // Nothing is lost by that: the option label above already prints the
      // chosen length, and it is the one place a visitor looks for it.
      els.selects.forEach(function (sel) {
        var i = Number(sel.dataset.wxIndex);

        [].slice.call(sel.options).forEach(function (opt) {
          if (!opt.value) return;
          if (!opt.dataset.wxLabel) opt.dataset.wxLabel = opt.textContent;
          // Availability, because the buttons show it and without this the
          // dropdown is the one place it stays invisible until you pick. Then a
          // tick on the chosen one, so reopening the list shows where you are
          // even though the closed control does not.
          var label = opt.dataset.wxLabel;
          if (!comboAvailable(i, opt.value)) label += ' (sold out)';
          if (opt.value === chosen[i]) label = '\u2713 ' + label;
          opt.textContent = label;
        });

        // Pinned to the placeholder on purpose. The visible text is the whole
        // point of the change; the real selection lives in `chosen`.
        sel.value = '';
        var onAButton = !!root.querySelector('[data-wx-option="' + i + '"] [data-wx-value="' + cssEscape(chosen[i]) + '"]');
        sel.classList.toggle('is-active', !onAButton);

        // A control whose visible value never moves has to say the selection
        // some other way, or a screen reader is told nothing changed.
        if (chosen[i]) sel.setAttribute('aria-label', 'More lengths, currently ' + pretty(chosen[i]));
      });

      // Keep the address bar honest so a shared or reloaded link lands on the
      // same variant, and so Shopify sees the variant on the page view.
      if (v && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      // Swap the gallery to the variant's own shot when it has one.
      //
      // Not on the first render when a lead image is set. The lead image exists
      // to be the first thing seen, and this ran on load and replaced it with
      // the variant's own photo before anyone had touched anything, which would
      // have made a first-impression split test measure nothing at all.
      // Once the visitor picks an option, the variant's shot is the right answer
      // again.
      if (v && v.featured_media && !(leadFirst && firstRender)) {
        var frame = root.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (frame) activate(Number(frame.dataset.wxFrame));
      }
      firstRender = false;
    }

    root.querySelectorAll('[data-wx-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { activate(Number(t.dataset.wxThumb)); });
    });

    // Liquid marks the first slide active with a class and nothing more. For an
    // image that is the whole job, because its src is inline. A clip in that
    // slot would sit on its poster until someone clicked a different thumb and
    // came back, so run the activation once for whatever is already active.
    var opening = root.querySelector('[data-wx-frame].is-active');
    if (opening) activate(Number(opening.dataset.wxFrame), true);

    if (stage) {
      var settle;
      stage.addEventListener('scroll', function () {
        // Everything is hydrated the moment a swipe starts, so the next frame
        // is never a blank panel mid-gesture.
        root.querySelectorAll('[data-wx-frame]').forEach(hydrate);
        window.clearTimeout(settle);
        settle = window.setTimeout(function () {
          if (!isSwipe() || !stage.clientWidth) return;
          activate(Math.round(stage.scrollLeft / stage.clientWidth), true);
        }, 90);
      }, { passive: true });
    }

    root.querySelectorAll('[data-wx-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = Number(btn.dataset.wxIndex);
        // Land on exactly what was clicked. If that combination is empty the
        // notify panel takes over from the cart row, which is a better answer
        // than silently moving someone to a length they did not ask for.
        chosen[index] = btn.dataset.wxValue;
        render();
      });
    });

    els.selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        if (!sel.value) return;
        chosen[Number(sel.dataset.wxIndex)] = sel.value;
        render();
      });
    });

    root.querySelectorAll('[data-wx-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var next = Number(els.qtyInput.value || 1) + Number(b.dataset.wxQty);
        els.qtyInput.value = Math.min(10, Math.max(1, next));
      });
    });

    function openCart() {
      var items = document.querySelector('cart-items');
      if (items && typeof items.getCart === 'function') { items.getCart(); return true; }
      var drawer = document.querySelector('cart-drawer');
      if (drawer) { drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); return true; }
      return false;
    }

    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available) return;

      els.atcs.forEach(function (b) { b.disabled = true; });
      if (els.error) els.error.hidden = true;

      // properties._lp rides on the line and lands in the order, which is what
      // makes conversions on this page countable from a Shopify export alone.
      // The cart attribute is the session-level backup for the same fact.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: v.id, quantity: Number(els.qtyInput.value || 1), properties: { _lp: lpId } }]
            .concat((charmState && charmState.picked || []).map(function (p) {
              // _for ties the charm to the piece it was ordered against, so the
              // studio can see which necklace an initial belongs to.
              return { id: p.id, quantity: 1, properties: { _lp: lpId, _for: v.id } };
            }))
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Could not add to bag');
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { wx_lp: lpId } })
          }).catch(function () { /* the line property is the record, this is the backup */ });
        })
        .then(function () {
          if (!openCart()) window.location.href = '/cart';
        })
        .catch(function (err) {
          if (els.error) { els.error.textContent = err.message || 'Could not add to bag'; els.error.hidden = false; }
        })
        .then(function () {
          els.atcs.forEach(function (b) { b.disabled = false; });
        });
    }

    els.atcs.forEach(function (b) { b.addEventListener('click', addToCart); });

    // Keep the last of our sections clear of the fixed bar. Measured rather
    // than assumed: the bar grows when a long product title wraps.
    function clearBar() {
      // A hidden element measures 0, so this is only meaningful once the bar is
      // on screen. Called again from the observer below the moment it appears,
      // otherwise the height stays at the fallback forever and the whole point
      // of measuring is lost.
      if (!bar || bar.hidden) return;
      var h = bar.getBoundingClientRect().height || 72;
      document.documentElement.style.setProperty('--wx-bar-h', Math.round(h) + 'px');
      var ours = document.querySelectorAll('.wx, .wx-mosaic, .wx-moment');
      if (!ours.length) return;
      ours.forEach(function (el) { el.classList.remove('wx-barclear'); });
      ours[ours.length - 1].classList.add('wx-barclear');
    }

    clearBar();
    window.addEventListener('resize', clearBar);

    // The bar takes over the moment the real button leaves the screen, and on
    // this page that happens within the first scroll and never reverses, so it
    // matters on desktop just as much as on a phone.
    var anchor = root.querySelector('[data-wx-cartrow]');
    if (anchor && bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.hidden = entries[0].isIntersecting;
        clearBar();
      }, { rootMargin: '0px 0px -40px 0px' }).observe(anchor);
    }

    /* ------------------------------------------------------------- initials */

    // Each charm is a real variant of the Letters or Numbers product and goes
    // into the cart as its own line, which is how the live product page does it
    // too. Prices are per character because the charms are solid gold and
    // priced on weight, so an M is not an I.
    var charms = null, charmState = null;
    var charmBlock = root.querySelector('[data-wx-charms-block]');

    if (charmBlock) {
      try {
        charms = JSON.parse(charmBlock.querySelector('[data-wx-charms]').textContent) || null;
      } catch (e) { charms = null; }
    }

    if (charms && Object.keys(charms).length) {
      var maxCharms = Number(charmBlock.dataset.max || 4);
      var kinds = Object.keys(charms);

      // The option order is read, not assumed: Shopify lets the merchant
      // reorder Size, Gold and the character at any time.
      kinds.forEach(function (k) {
        var names = charms[k].options.map(function (n) { return String(n).toLowerCase(); });
        charms[k].ix = {
          size: names.findIndex(function (n) { return n.indexOf('size') > -1; }),
          gold: names.findIndex(function (n) { return n.indexOf('gold') > -1 || n.indexOf('metal') > -1; })
        };
        charms[k].ix.character = [0, 1, 2].find(function (i) {
          return i !== charms[k].ix.size && i !== charms[k].ix.gold;
        });
        var uniq = function (i) {
          var out = [];
          charms[k].variants.forEach(function (v) {
            if (out.indexOf(v.o[i]) < 0) out.push(v.o[i]);
          });
          return out;
        };
        charms[k].sizes = uniq(charms[k].ix.size);
        charms[k].golds = uniq(charms[k].ix.gold);
        charms[k].chars = uniq(charms[k].ix.character).sort();
      });

      charmState = { kind: kinds[0], size: null, gold: null, picked: [] };
      charmState.size = charms[charmState.kind].sizes[0];
      charmState.gold = charms[charmState.kind].golds[0];

      var els2 = {
        toggle: charmBlock.querySelector('[data-wx-charm-toggle]'),
        panel: charmBlock.querySelector('[data-wx-charm-panel]'),
        kindsRow: charmBlock.querySelector('[data-wx-charm-kinds]'),
        sizesRow: charmBlock.querySelector('[data-wx-charm-sizes]'),
        goldsRow: charmBlock.querySelector('[data-wx-charm-golds]'),
        grid: charmBlock.querySelector('[data-wx-charm-grid]'),
        list: charmBlock.querySelector('[data-wx-charm-list]')
      };

      function findCharm(kind, ch) {
        var c = charms[kind], ix = c.ix;
        return c.variants.find(function (v) {
          return v.o[ix.character] === ch && v.o[ix.size] === charmState.size && v.o[ix.gold] === charmState.gold;
        }) || null;
      }

      function pills(host, values, active, attr) {
        host.innerHTML = values.map(function (v) {
          return '<button type="button" class="wx-buy__charmpill' + (v === active ? ' is-active' : '') +
                 '" ' + attr + '="' + String(v).replace(/"/g, '&quot;') + '">' + v + '</button>';
        }).join('');
      }

      function renderCharms() {
        var c = charms[charmState.kind];
        if (kinds.length > 1) {
          pills(els2.kindsRow, kinds.map(function (k) { return charms[k].title; }), charms[charmState.kind].title, 'data-wx-charm-kind');
        } else {
          els2.kindsRow.innerHTML = '';
        }
        pills(els2.sizesRow, c.sizes, charmState.size, 'data-wx-charm-size');
        pills(els2.goldsRow, c.golds, charmState.gold, 'data-wx-charm-gold');

        els2.grid.innerHTML = c.chars.map(function (ch) {
          var v = findCharm(charmState.kind, ch);
          var ok = v && v.a;
          return '<button type="button" class="wx-buy__char" data-wx-charm-pick="' + ch + '"' +
                 (ok ? '' : ' disabled') + '>' + ch + '</button>';
        }).join('');

        els2.list.innerHTML = charmState.picked.map(function (p, i) {
          return '<li><span>' + p.label + '</span><span>' + money(p.price) +
                 '<button type="button" class="wx-buy__charmx" data-wx-charm-remove="' + i +
                 '" aria-label="Remove ' + p.label + '">&times;</button></span></li>';
        }).join('');

        if (charmState.picked.length) {
          var sum = charmState.picked.reduce(function (a, p) { return a + p.price; }, 0);
          var v = currentVariant();
          els2.list.innerHTML +=
            '<li class="wx-buy__charmtotal"><span>With ' + charmState.picked.length +
            (charmState.picked.length === 1 ? ' charm' : ' charms') + '</span><span>' +
            money(sum + (v ? v.price : 0)) + '</span></li>';
        }
      }

      els2.toggle.addEventListener('click', function () {
        var open = els2.toggle.getAttribute('aria-expanded') === 'true';
        els2.toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
        els2.panel.hidden = open;
        if (!open) renderCharms();
      });

      charmBlock.addEventListener('click', function (e) {
        var t = e.target;
        var kindBtn = t.closest('[data-wx-charm-kind]');
        if (kindBtn) {
          var want = kinds.find(function (k) { return charms[k].title === kindBtn.dataset.wxCharmKind; });
          if (want) {
            charmState.kind = want;
            // Numbers have no Large, so a size carried over from Letters would
            // resolve to nothing.
            if (charms[want].sizes.indexOf(charmState.size) < 0) charmState.size = charms[want].sizes[0];
            if (charms[want].golds.indexOf(charmState.gold) < 0) charmState.gold = charms[want].golds[0];
          }
          renderCharms(); return;
        }
        var sizeBtn = t.closest('[data-wx-charm-size]');
        if (sizeBtn) { charmState.size = sizeBtn.dataset.wxCharmSize; repriceCharms(); renderCharms(); return; }
        var goldBtn = t.closest('[data-wx-charm-gold]');
        if (goldBtn) { charmState.gold = goldBtn.dataset.wxCharmGold; repriceCharms(); renderCharms(); return; }
        var pick = t.closest('[data-wx-charm-pick]');
        if (pick) {
          if (charmState.picked.length >= maxCharms) return;
          var ch = pick.dataset.wxCharmPick;
          var v = findCharm(charmState.kind, ch);
          if (!v || !v.a) return;
          charmState.picked.push({
            id: v.i, price: v.p, ch: ch, kind: charmState.kind,
            label: ch + ', ' + charmState.size.toLowerCase() + ', ' + charmState.gold.toLowerCase() + ' gold'
          });
          renderCharms(); return;
        }
        var rm = t.closest('[data-wx-charm-remove]');
        if (rm) { charmState.picked.splice(Number(rm.dataset.wxCharmRemove), 1); renderCharms(); }
      });

      // Size and metal apply to everything already chosen, so the chips have to
      // be repriced onto the new variants rather than left on the old ones.
      function repriceCharms() {
        charmState.picked = charmState.picked.map(function (p) {
          var v = findCharm(p.kind, p.ch);
          if (!v) return p;
          return {
            id: v.i, price: v.p, ch: p.ch, kind: p.kind,
            label: p.ch + ', ' + charmState.size.toLowerCase() + ', ' + charmState.gold.toLowerCase() + ' gold'
          };
        });
      }

      renderCharms();
    }

    // The countdown runs to a cutoff in the store's own timezone, not the
    // visitor's, because the studio in Los Angeles is what the cutoff is about.
    // It says nothing about how fast the piece then ships: the shipping policy
    // is 2 to 10 business days and this line must never contradict it.
    function tickShip() {
      if (!els.ship) return;
      var cutoff = Number(els.ship.dataset.cutoff);
      if (!isFinite(cutoff)) { els.ship.hidden = true; return; }

      // The store's wall clock, from Intl rather than a stored offset.
      //
      // This used to take store_utc_offset, a number a human typed, defaulted to
      // -7. Los Angeles is -7 on daylight time and -8 the rest of the year, so
      // every November the cutoff quietly moved an hour and the line stayed
      // confidently wrong until somebody noticed. The offset setting is kept as
      // a fallback for a browser without Intl, and nothing else.
      var tz = els.ship.dataset.tz;
      var h, m, sec;
      var got = false;
      if (tz && window.Intl && Intl.DateTimeFormat) {
        try {
          var f = new Intl.DateTimeFormat('en-US', {
            timeZone: tz, hour12: false,
            hour: '2-digit', minute: '2-digit', second: '2-digit'
          });
          var p = {};
          f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
          h = +p.hour % 24; m = +p.minute; sec = +p.second;
          got = true;
        } catch (e) { got = false; }
      }
      if (!got) {
        var offset = Number(els.ship.dataset.tzOffset);
        if (!isFinite(offset)) { els.ship.hidden = true; return; }
        var now = new Date();
        var store = new Date(now.getTime() + (now.getTimezoneOffset() * 60000) + (offset * 3600000));
        h = store.getHours(); m = store.getMinutes(); sec = store.getSeconds();
      }

      var left = cutoff * 3600 - (h * 3600 + m * 60 + sec);

      // Past the cutoff the countdown rolls to tomorrow's run rather than
      // disappearing, so the line is true at every hour of the day.
      var tpl = els.ship.dataset.template;
      if (left <= 0) {
        left += 86400;
        tpl = els.ship.dataset.templateAfter || tpl;
      }
      if (left <= 0 || left > 86400) { els.ship.hidden = true; return; }

      var hh = Math.floor(left / 3600);
      var mm = Math.floor(left / 60) % 60;
      var ss = Math.floor(left) % 60;
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var text = hh > 0 ? hh + 'h ' + pad(mm) + 'm ' + pad(ss) + 's'
                        : mm + 'm ' + pad(ss) + 's';
      els.ship.innerHTML = (tpl || 'Order within {time}').replace('{time}', '<b>' + text + '</b>');
      els.ship.hidden = false;
    }

    tickShip();
    window.setInterval(tickShip, 1000);

    render();

    // Once the page has settled, fill in the rest of the gallery so swiping
    // through it is instant. LCP has already happened by then.
    var rest = function () {
      root.querySelectorAll('[data-wx-frame]').forEach(hydrate);
    };
    if (window.requestIdleCallback) {
      window.requestIdleCallback(rest, { timeout: 3000 });
    } else {
      window.setTimeout(rest, 1200);
    }
  }

  /* ------------------------------------------------------------ disclosures */

  function initDelegates() {
    document.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-wx-faq-q]');
      if (q) {
        var open = q.getAttribute('aria-expanded') === 'true';
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var panel = document.getElementById(q.getAttribute('aria-controls'));
        if (panel) panel.hidden = open;
        return;
      }

      var barJump = e.target.closest && e.target.closest('[data-wx-bar-jump]');
      if (barJump) {
        var buy = document.getElementById('wx-buy');
        if (buy) {
          buy.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }
        return;
      }

      var jump = e.target.closest && e.target.closest('[data-wx-jump]');
      if (jump) {
        var target = document.querySelector(jump.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      }
    });
  }

  /* ------------------------------------------------------------ pair offer */

  function initBump() {
    var root = document.querySelector('[data-wx-bump]');
    if (!root) return;

    var btn = root.querySelector('[data-wx-bump-add]');
    var pick = root.querySelector('[data-wx-bump-variant]');
    var err = root.querySelector('[data-wx-bump-error]');
    if (!btn || !pick) return;

    btn.addEventListener('click', function () {
      // The base variant is read at click time from the buy box, so the pair
      // adds whatever length the visitor actually chose rather than whatever
      // the page was rendered with.
      var baseInput = document.querySelector('[data-wx-buybox] [data-wx-price]');
      var baseId = root.dataset.baseVariant;
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant')) baseId = url.searchParams.get('variant');

      var code = root.dataset.discountCode;
      // Read from the section, never a literal. A hardcoded id here silently
      // attributed the pair offer to variant A on every page.
      var pairLp = (document.querySelector('[data-lp-id]') || {}).dataset
                 ? document.querySelector('[data-lp-id]').dataset.lpId
                 : (root.dataset.lpId || 'wx-lp');
      btn.disabled = true;
      if (err) err.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: Number(baseId), quantity: 1, properties: { _lp: pairLp, _pair: 'yes' } },
            { id: Number(pick.value), quantity: 1, properties: { _lp: pairLp, _pair: 'yes' } }
          ]
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data && res.data.description ? res.data.description : 'Could not add the pair');
          // Applying the code server side rather than trusting an automatic
          // discount to exist. Verify at checkout before this goes live.
          if (code) return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
        })
        .then(function () {
          var items = document.querySelector('cart-items');
          if (items && typeof items.getCart === 'function') { items.getCart(); return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer) { drawer.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); return; }
          window.location.href = '/cart';
        })
        .catch(function (e) {
          if (err) { err.textContent = e.message || 'Could not add the pair'; err.hidden = false; }
        })
        .then(function () { btn.disabled = false; });
    });
  }

  /* -------------------------------------------------------------- swipe rails

     One scroller, arrows, and ends that disable. Used by the reviews, the size
     ladder, and anything added later: a rail is a row plus two buttons and
     nothing else, so copying it a third time only creates a third place for the
     step size to drift.
     ------------------------------------------------------------------------ */

  function initRail(rowSel, prevSel, nextSel) {
    var row = document.querySelector(rowSel);
    if (!row) return;
    var prev = document.querySelector(prevSel);
    var next = document.querySelector(nextSel);
    if (!prev || !next) return;

    function step() {
      var card = row.firstElementChild;
      if (!card) return row.clientWidth;
      // The real gap, not a number typed here. The review rail carried + 18
      // against a 14px gap, so every press landed four pixels off the snap point
      // and the rail crept out of alignment down the row.
      var gap = parseFloat(getComputedStyle(row).columnGap);
      return card.getBoundingClientRect().width + (gap || 0);
    }

    function sync() {
      prev.disabled = row.scrollLeft < 8;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
    }

    prev.addEventListener('click', function () { row.scrollLeft -= step(); });
    next.addEventListener('click', function () { row.scrollLeft += step(); });
    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initReviewRail() {
    initRail('[data-wx-rev-row]', '[data-wx-rev-prev]', '[data-wx-rev-next]');
  }

  function initSizeRail() {
    var row = document.querySelector('[data-wx-size-row]');
    if (!row) return;
    initRail('[data-wx-size-row]', '[data-wx-size-prev]', '[data-wx-size-next]');

    // Only the cards you can see keep decoding.
    //
    // The first attempt capped the count and paused whichever clip had started
    // longest ago. That is the first card, which is the one you scroll back to,
    // so the choker sat frozen. On a 1440px screen five cards fit at once, so it
    // froze on arrival without anyone even swiping.
    //
    // Position decides it now, not age. It runs when the rail has STOPPED, once,
    // rather than on every scroll event: nothing is paused mid swipe, so the
    // play/pause pair that caused the stutter in the tall reel cannot form here
    // either. Vertical page scrolling does not move this rail, so scrolling the
    // page fires none of it.
    var settle = null;

    function syncPlayback() {
      var rail = row.getBoundingClientRect();
      [].forEach.call(row.children, function (card) {
        var v = card.querySelector('video');
        if (!v) return;
        var c = card.getBoundingClientRect();
        var onScreen = c.right > rail.left + 8 && c.left < rail.right - 8;
        // A clip with no source yet belongs to the deferred loader, which starts
        // it when it arrives. Calling play on it here would only warm a video
        // element with nothing in it.
        if (onScreen) { if (v.paused && v.currentSrc) play(v); }
        else if (!v.paused) v.pause();
      });
    }

    function play(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* a browser that refuses autoplay is fine */ });
    }

    row.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(syncPlayback, 180);
    }, { passive: true });
    window.addEventListener('resize', function () {
      clearTimeout(settle);
      settle = setTimeout(syncPlayback, 180);
    });
  }

  /* -------------------------------------------------------- recommendations */

  function initRecommendations() {
    var root = document.querySelector('[data-wx-rec]');
    if (!root) return;
    var row = root.querySelector('[data-wx-rec-row]');
    var id = root.dataset.productId;
    var limit = Number(root.dataset.limit || 8);
    var lpId = root.dataset.lpId || '';
    if (!row || !id) return;

    // Letters and Numbers are the customization add-on on the product page, not
    // pieces the brand sells on their own, so they never appear in anything
    // outward facing. Handles cover it today; the tag makes it self maintaining
    // the moment anything is tagged in Shopify.
    var blockedHandles = (root.dataset.excludeHandles || '')
      .split(',').map(function (h) { return h.trim().toLowerCase(); }).filter(Boolean);
    var blockedTag = (root.dataset.excludeTag || '').trim().toLowerCase();

    function allowed(p) {
      if (blockedHandles.indexOf(String(p.handle || '').toLowerCase()) > -1) return false;
      if (blockedTag && (p.tags || []).some(function (t) {
        return String(t).trim().toLowerCase() === blockedTag;
      })) return false;
      return true;
    }

    var money = wxMoney;

    function esc(v) {
      return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    // Shopify's own algorithm, the same one the live theme uses, so it stays
    // current and can never offer something that has left the catalog.
    // Always ask for the maximum and filter afterwards. Asking for exactly six
    // and then removing the add-on leaves five.
    fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) +
          '&limit=10', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var items = ((d && d.products) || []).filter(allowed);

        // Ten is the endpoint's ceiling, so anything beyond it comes from the
        // list the section rendered. Recommendations keep their order and the
        // pool fills in behind, deduped on handle.
        if (items.length < limit) {
          var pool = [];
          try {
            var node = root.querySelector('[data-wx-rec-fallback]');
            if (node) pool = JSON.parse(node.textContent) || [];
          } catch (e) { pool = []; }
          var have = {};
          items.forEach(function (p) { have[String(p.handle).toLowerCase()] = 1; });
          pool.forEach(function (p) {
            if (items.length >= limit) return;
            var h = String(p.handle || '').toLowerCase();
            if (have[h] || !allowed(p)) return;
            have[h] = 1;
            items.push(p);
          });
        }

        items = items.slice(0, limit);
        if (!items.length) return;

        var cards = items.map(function (p) {
          // The API returns an object for images on some shapes and a string on
          // others, and the rendered pool returns a URL. Handle all three.
          var img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && typeof img === 'object') img = img.src || '';
          if (img && img.indexOf('//') === 0) img = 'https:' + img;
          var src = img ? img.split('?')[0] + '?width=420' : '';
          return '<a class="wx-rec__card" href="' + esc(p.url || ('/products/' + p.handle)) + '"' +
                 ' data-wx-rec-link>' +
                 '<span class="wx-rec__shot">' +
                 (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy" width="210" height="210">' : '') +
                 '</span>' +
                 '<span class="wx-rec__name">' + esc(p.title) + '</span>' +
                 '<span class="wx-rec__price">' +
                 (p.available === false ? '<span class="wx-rec__sold">Sold out</span>'
                                        : (p.price_varies ? 'From ' : '') + money(p.price)) +
                 '</span></a>';
        });

        // A last card out to the full collection, so the rail ends in a door
        // rather than a dead stop.
        var moreUrl = root.dataset.moreUrl;
        if (moreUrl) {
          cards.push(
            '<a class="wx-rec__card wx-rec__card--more" href="' + esc(moreUrl) + '"' +
            ' data-wx-rec-link data-wx-exit="view-all">' +
            '<span class="wx-rec__shot wx-rec__more"><span class="wx-rec__arrow" aria-hidden="true"></span></span>' +
            '<span class="wx-rec__name">' + esc(root.dataset.moreLabel || 'View more') + '</span>' +
            '<span class="wx-rec__price">' + esc(root.dataset.moreSub || '') + '</span></a>'
          );
        }

        row.innerHTML = cards.join('');
        root.hidden = false;
        wireRecRail(root, row);
      })
      .catch(function () { /* the section simply stays hidden */ });

    // The click has to leave a mark before the page changes, or a visitor who
    // arrives here, clicks through and buys a different piece is revenue this
    // page earned with nothing to show for it. keepalive so the write survives
    // the navigation.
    row.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-wx-rec-link]');
      if (!lpId || !link) return;
      try {
        fetch('/cart/update.js', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              wx_lp: lpId,
              // Which door they left by, so browsing the whole collection can be
              // told apart from taking a specific recommendation.
              wx_lp_exit: link.dataset.wxExit || 'recommendation'
            }
          })
        });
      } catch (err) { /* never block the navigation */ }
    });
  }

  function wireRecRail(root, row) {
    var prev = root.querySelector('[data-wx-rec-prev]');
    var next = root.querySelector('[data-wx-rec-next]');
    if (!prev || !next) return;
    function step() {
      var c = row.firstElementChild;
      return c ? c.getBoundingClientRect().width + 16 : 220;
    }
    function sync() {
      prev.disabled = row.scrollLeft < 8;
      next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 8;
    }
    prev.addEventListener('click', function () { row.scrollLeft -= step(); });
    next.addEventListener('click', function () { row.scrollLeft += step(); });
    row.addEventListener('scroll', sync, { passive: true });
    sync();
  }

  function boot() { initBuybox(); initBump(); initReviewRail(); initSizeRail(); initRecommendations(); initDelegates(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* ---------------------------------------------------------------------------
   Deferred video

   autoplay defeats preload="none": the browser fetches the file regardless, so
   610KB was arriving on every visit whether or not anyone reached the section
   it plays in. The source ships as data-wx-src and is promoted to src only when
   the section is close to the viewport, which is the only point at which the
   bytes buy anything.
   ------------------------------------------------------------------------- */
(function () {
  var vids = [].slice.call(document.querySelectorAll('[data-wx-video]'));
  if (!vids.length) return;

  function load(v) {
    var src = v.querySelector('source[data-wx-src]');
    if (!src) return false;
    src.src = src.getAttribute('data-wx-src');
    src.removeAttribute('data-wx-src');
    v.load();
    return true;
  }

  function play(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* a browser that refuses autoplay is fine */ });
  }

  if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { load(v); play(v); }); return; }

  // Load when it comes near, play once, and then leave it alone.
  //
  // The previous version paused whenever the element stopped intersecting, to
  // save decoding. On a phone that made it worse, not better: scrolling INSIDE a
  // tall video crosses the threshold repeatedly, so play() and pause() chase
  // each other, every play() returns a promise that the next pause() rejects,
  // and the result is exactly the stutter it was meant to prevent. A paused
  // video also lets iOS resume its idle timer, which dims the screen, so the
  // section appeared to darken while you were looking at it and recover once you
  // scrolled past.
  //
  // The section that never misbehaved simply loads and plays. So does this one
  // now. The only pause left is the one that cannot thrash.
  var warm = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      warm.unobserve(e.target);
      load(e.target);
      play(e.target);
    });
  }, { rootMargin: '600px 0px' });

  vids.forEach(function (v) { warm.observe(v); });

  // A backgrounded tab keeps decoding otherwise, which is the same cost with
  // nobody watching.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    vids.forEach(function (v) { if (!v.paused) v.pause(); });
  });
})();
